/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of source for the image export.
 */
export enum ImageExportSourceType {
  ImageExportSourceTypeImageBuild = 'imageBuild',
}
